module.exports = __webpack_public_path__ + "img/路径 2.84496f31.png";